import { useMemo } from 'react'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  return useMemo(() => {
    let filters = Array.isArray(
      data?.user_location_preferences_by_pk?.timeline_filter_presets
    )
      ? data.user_location_preferences_by_pk.timeline_filter_presets
      : []

    if (filters.length === 0) {
      filters = [
        {
          id: 'appointment',
          text: 'Appointments',
          value: true,
        },
        {
          id: 'note',
          text: 'Treatment Notes',
          value: true,
        },
        {
          id: 'order',
          text: 'Orders',
          value: true,
        },
      ]
    }

    let ids = new Set(filters.map(item => item.id))

    if (
      Array.isArray(data?.apps_displays.displays) &&
      data.apps_displays.displays.length > 0
    ) {
      filters = [
        ...filters,
        ...data.apps_displays.displays
          .filter(display => !ids.has(display.resourceType))
          .map(display => ({
            id: display.resourceType,
            text: display.props.name,
            value: true,
            custom_resource: true,
          }))
          .sort((a, b) => a.text.localeCompare(b.text)),
      ]
    }

    return {
      user_id: data?.user_id,
      location_id: data?.location_id,
      timeline_filter_presets: filters,
    }
  }, [data])
}
